module.exports = __webpack_public_path__ + "media/slick.ced611da.eot";


//////////////////
// WEBPACK FOOTER
// ./node_modules/slick-carousel/slick/fonts/slick.eot
// module id = +bHc
// module chunks = 0